import allPaths from '../Config/paths'

// Public, login-free page showing one vehicle's live timetable. The page
// resolves the vehicle by its device: display ID (devices_info.ud_sn, e.g.
// "E1812") or the device serial number.
export const routeForecastUrl = (device) => {
    const id = String(device || '').trim()
    return id ? `${allPaths?.ROUTE_FORECAST}/${encodeURIComponent(id)}` : null
}
